import React, { useContext, useState } from "react";
import Avater from "../assits/profile.jpg";
import { BASE_URL, UserContext } from "../contexts/UserContext";
import { Link } from "react-router-dom";
import { FaCheck, FaEdit } from "react-icons/fa";
import axios from "axios";
import Loader from "../components/Loader/Loader";
import ButtonLoader from "../components/ButtonLoader";



const UserProfile = () => {
  const { currentUser, error, setCurrentUser, setMessage, setError } =
    useContext(UserContext);
  const [avater, setAvater] = useState(currentUser?.profile.secure_url || Avater);
  const [name, setName] = useState(currentUser.name);
  const [username, setUsername] = useState(currentUser.username);
  const [email, setEmail] = useState(currentUser.email);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [prvAvater, setPrvAvater] = useState("");
  const [avater2, setAvater2] = useState("");



  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {

      const { data } = await axios.put(
        `${BASE_URL}/users/update/my-profile`,
        { username, email, name },

        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      setCurrentUser(data?.user);
      setMessage(data?.message);
      setError(null);
    } catch (error) {
      setError(error.response.data.message);
      setMessage(null);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {

      const { data } = await axios.put(
        `${BASE_URL}/users/update/my-password`,
        { oldPassword: currentPassword, password: newPassword, conformPassword: confirmNewPassword },

        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      setCurrentUser(data?.user);
      setMessage(data?.message);
      setError(null);
      setConfirmNewPassword("")
      setCurrentPassword("")
      setNewPassword("")
    } catch (error) {
      setError(error?.response?.data.message);
      setMessage(null);
    } finally {
      setLoading(false);
    }
  };


  const handleUPdateProfileImage = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.put(`${BASE_URL}/users/update/my-profile-photo`,
        {
          photo: avater2
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      )
      setCurrentUser(data.user);
      setMessage(data.message);
      setError(null);
      setPrvAvater(null)
    } catch (error) {
      setError(error.response.data.message);
      setMessage(null);
    } finally {
      setLoading(false)
    }
  }

  const changeAvater = (e) => {
    setAvater2(e.target.files[0])
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        setPrvAvater(reader.result);
        setAvater(reader.result);
      }
    };

    reader.readAsDataURL(e.target.files[0]);
  };
  if (!currentUser) return;


  return (
    <section className="profile">
      {!currentUser ? (
        <Loader />
      ) : (
        <div className="container profile__container">
          <Link to={`/myposts/${currentUser._id}`} className="btn">
            My Posts
          </Link>
          <div className="profile__details">
            <div className="avatar__wrapper">
              <div className="profile__avatar">
                <img src={avater} alt="" />
              </div>
              <div className="avatar__form">
                <input
                  type="file"
                  name="avatar"
                  accept="image/*"
                  onChange={(e) => changeAvater(e)}
                  id="avatar"
                />
                {
                  prvAvater ? (
                    <button className="profile__avatar-btn"  onClick={handleUPdateProfileImage}>
                      {
                        loading ? <ButtonLoader /> : <FaCheck />
                      }
                    </button>
                  ) : (
                    <label htmlFor="avatar">

                      <FaEdit />

                    </label>
                  )
                }

              </div>

            </div>
            <div className="form profile__form">
              {error && <p className="form__error-message">{error}</p>}
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              <input
                type="text"
                placeholder="Full Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                type="text"
                placeholder="Current password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
              <input
                type="text"
                placeholder="New password"
                value={newPassword}
                style={{ border: '1px solid transparent', borderColor: newPassword && confirmNewPassword && newPassword === confirmNewPassword ? '#32CD32' : 'red' }}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <input
                type="text"
                placeholder="Confirm new password"
                value={confirmNewPassword}
                style={{ border: '1px solid transparent', borderColor: newPassword && confirmNewPassword && newPassword === confirmNewPassword ? '#32CD32' : 'red' }}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
              />
              <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'start' }}>
                <button
                  type="submit"
                  onClick={(e) => handleUpdateProfile(e)}
                  className="btn primary"

                >
                  {
                    !loading ? "Update Profile" : <ButtonLoader />
                  }

                </button>
                {currentPassword && newPassword && confirmNewPassword && <button className="btn warning" onClick={handleChangePassword}>
                  {
                    !loading ? "Update Password" : <ButtonLoader />
                  }
                </button>}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default UserProfile;
